module.exports = __webpack_public_path__ + "static/media/email.3c349657.png";